import { useLocation, useNavigate, Link } from 'react-router-dom';
import useWorkspaces from '../../../hooks/useWorkspaces';
import useDisclosure from '../../../hooks/useDisclosure';
import { paths } from '../../../routes/paths';
import Icon from '../../ui/Icon/Icon';
import CreateWorkspaceModal from '../../workspace/CreateWorkspaceModal/CreateWorkspaceModal';
import styles from './WorkspaceRail.module.css';

// Left rail with workspace switcher. Items styled as terminal commands.
// On mobile it acts as an off-canvas drawer: hidden by default, slides in
// from the left when `drawerOpen` is true; `onClose` dismisses it.
export default function WorkspaceRail({ drawerOpen, onClose }) {
  const { workspaces, createWorkspace } = useWorkspaces();
  const navigate = useNavigate();
  const location = useLocation();
  const createModal = useDisclosure();

  // Active workspace = the id in the current path (/workspaces/:id...).
  const match = location.pathname.match(/^\/workspaces\/([^/]+)/);
  const activeId = match ? match[1] : null;

  const handleCreate = async (name) => {
    const id = await createWorkspace(name);
    navigate(paths.workspace(id));
    onClose?.();
  };

  const handleNavigate = (id) => {
    navigate(paths.workspace(id));
    onClose?.();
  };

  return (
    <nav className={`${styles.rail} ${drawerOpen ? styles.railOpen : ''}`}>
      <div className={styles.railTop}>
        <Link to={paths.workspaces} className={styles.brand} title="Sabiá Home" onClick={onClose}>
          <span className={styles.logoBox}>
            <span className={styles.logoImage} aria-label="Sabiá" />
          </span>
          <span className={styles.brandText}>
            <span className={styles.brandName}>Sabiá</span>
            <span className={styles.brandTag}>v0.1.0-alpha</span>
          </span>
        </Link>

        <button
          type="button"
          className={styles.drawerClose}
          onClick={onClose}
          aria-label="Close menu"
        >
          <Icon name="X" size={18} />
        </button>
      </div>

      <div className={styles.sectionLabel}>{'// workspaces'}</div>

      <div className={styles.items}>
        {workspaces.map((ws) => {
          const active = ws.id === activeId;
          return (
            <button
              key={ws.id}
              type="button"
              className={`${styles.item} ${active ? styles.active : ''}`}
              title={ws.name}
              onClick={() => handleNavigate(ws.id)}
            >
              <span className={styles.itemLabel}>{ws.name || 'untitled'}</span>
            </button>
          );
        })}
      </div>

      <button
        type="button"
        className={styles.add}
        title="Create workspace"
        onClick={createModal.open}
      >
        <Icon name="Plus" size={14} />
        New workspace
      </button>

      <CreateWorkspaceModal
        isOpen={createModal.isOpen}
        onClose={createModal.close}
        onCreate={handleCreate}
      />
    </nav>
  );
}
